import { FunctionComponent, useState } from 'react';
import styles from "./FishinityProCenter.module.css";
import cn from 'classnames';
import SidebarLayout from '../../../component/common/Layout/SidebarLayout/SidebarLayout';
import CustomMap from '../../../component/UI/CustomMap/CustomMap';
import TextHeader from '../../../component/common/TextHeader/TextHeader';
// import ContentTabs from '../../../component/common/ContentTabs/ContentTabs';
import SearchInput from '../../../component/common/SearchInput/SearchInput';
import { ASSESTS } from '../../../constant/assest';
import LocationReviews from '../../../component/UI/LocationReviews/LocationReviews';
import UsersFishData from '../../../component/UI/UsersFishData/UsersFishData';

const FishinityProCenter: FunctionComponent = () => {

    // const [activeContentTab, setActiveContentTab] = useState('Logbook Pro');

    return (
        <SidebarLayout>
            <div className={cn(styles.fisherProPage)}>
                <div className={styles.rowOne}>
                    <TextHeader 
                        title={'Fishinity Pro Center'} 
                        summary={"Manage locations, review user submissions, and monitor fish data"}
                        className='mb-0'
                    />
                    {/* <div>
                        <ContentTabs tabs={['Logbook Pro', 'Catch Data', 'Invite Friends', 'Fly’s & Lures']} 
                            defaultActiveTab={activeContentTab} 
                            tabOnClick={(tab) => setActiveContentTab(tab)} 
                        />
                    </div> */}
                    <SearchInput 
                        placeholder='Search Fishinity Pro Centre database...' 
                        className={cn(styles.fisherProSearch, 'mb-0')}
                    />
                    <div className={styles.mapSection}>
                        <div className={styles.title}>Interactive Map</div>
                        <CustomMap content={[
                                {
                                    id: 1,
                                    name: 'Jamie Waters',
                                    position: { lat: 42.2342071, lng: -88.3565594 },
                                    adminImg: '',
                                    gallery: [
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                    ],
                                },
                                {
                                    id: 2,
                                    name: 'Taylor Stream',
                                    position: { lat: 42.2342071, lng: -88.345 },
                                    adminImg: ASSESTS.MAPADMINDUMMY,
                                    gallery: [
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                        ASSESTS.MAPGALLERYDUMMY,
                                    ],
                                },
                            ]}
                            mapOptions={{
                                mapView: {lat: 42.2342071, lng: -88.3565594,},
                                APIKey: "AIzaSyAOVYRIgupAurZup5y1PRh8Ismb1A3lLao",
                                mapZoom: 16
                            }}
                        />
                    </div>
                </div>
                <div className={styles.rowTwo}>
                    <LocationReviews 
                        title={'Pending Location Reviews'} 
                    />
                    <UsersFishData />
                </div>
            </div>
        </SidebarLayout>
    );
};

export default FishinityProCenter;